// Visibilidade de fotos CAPTURADAS e LÂMINAS por perfil (Ajuste 2 — 30/06/2026).
//
// Regra do cliente:
//  - Veem: Diretor(master), Administrador(administrator), Vendedor(seller),
//    Editor(editor) e Inspetor(inspector).
//  - A partir de um certo ponto do fluxo, só Diretor, Administrador e Editor
//    (saem Vendedor e Inspetor).
//
// O ponto de corte é DIFERENTE para cada tipo (esclarecido pelo dono 01/07):
//  - CAPTURADAS: ocultas para Vendedor/Inspetor DEPOIS de EDITADAS. Ou seja, assim
//    que a edição termina ('Editado' em diante) — o inspetor inspeciona a foto
//    EDITADA, não deve mais ver a capturada.
//  - LÂMINAS: só depois que o pedido vai para PRODUÇÃO ('Em impressão' em diante),
//    para o Inspetor ainda conseguir inspecionar as lâminas antes disso.

// Sequência canônica dos status do pedido (mesma ordem do enum OrderStatus no back).
const ORDER_STATUS_SEQUENCE = [
  'Financeiro negado',
  'Arquivado',
  'Em inclusão',
  'Incluído',
  'Análise financeira',
  'Financeiro aprovado',
  'Em edição',
  'Editado',
  'Inspeção de edição',
  'Edição aprovada',
  'Em edição de lâminas',
  'Lâminas editadas',
  'Inspeção de edição de lâminas',
  'Edição de lâminas aprovada',
  'Em impressão',
  'Impresso',
  'Em plotter',
  'Plotado',
  'Em montagem',
  'Montado',
  'Em embalagem',
  'Embalado',
  'Em expedição',
  'Enviado',
  'Recebido na unidade',
  'Entregue',
];

const indexOfStatus = (order_status) =>
  ORDER_STATUS_SEQUENCE.indexOf(order_status);

// True quando as fotos JÁ FORAM EDITADAS ('Editado' em diante). Corte das capturadas.
export const isAfterEditing = (order_status) => {
  const idx = indexOfStatus(order_status);
  return idx >= 0 && idx >= indexOfStatus('Editado');
};

// True quando o pedido já foi para produção ('Em impressão' em diante). Corte das lâminas.
export const isInProductionOrBeyond = (order_status) => {
  const idx = indexOfStatus(order_status);
  return idx >= 0 && idx >= indexOfStatus('Em impressão');
};

// True quando o pedido já chegou na fase de lâminas ('Em edição de lâminas' em
// diante). Antes disso a seção de lâminas é só ruído (ex.: 'Em inclusão').
export const isSpreadEditingOrBeyond = (order_status) => {
  const idx = indexOfStatus(order_status);
  return idx >= 0 && idx >= indexOfStatus('Em edição de lâminas');
};

// Perfis que veem as fotos CAPTURADAS: após editadas, só master/admin/editor.
export const canViewCapturedPhotos = (hasRoles, order_status) =>
  isAfterEditing(order_status)
    ? hasRoles(['master', 'administrator', 'editor'])
    : hasRoles(['master', 'administrator', 'seller', 'editor', 'inspector']);

// Perfis que veem as LÂMINAS. O IMPRESSOR (print_photos) SEMPRE vê as lâminas
// (precisa acompanhar/preparar a impressão) — o download continua restrito à
// janela dele ('Em impressão'). Fora o impressor: antes da produção veem
// master/admin/seller/editor/inspector; após a produção só master/admin/editor.
export const canViewSpreadPhotos = (hasRoles, hasPermissions, order_status) => {
  if (hasPermissions(['print_photos'])) return true;

  return isInProductionOrBeyond(order_status)
    ? hasRoles(['master', 'administrator', 'editor'])
    : hasRoles(['master', 'administrator', 'seller', 'editor', 'inspector']);
};
